import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNoshStore } from '../../lib/store';
import ScanResultsModal from './scan-results-modal';

export function GlobalScanResultsModal() {
  const { scanResults, hideScanResults } = useNoshStore();

  // Debug logging - only log when modal opens
  useEffect(() => {
    if (scanResults.showModal) {
      console.log('🔍 [Global Scan Results Modal] Opening modal with data:', {
        hasData: !!scanResults.scanData,
        itemCount: scanResults.scanData?.items?.length || 0,
        hasError: !!scanResults.error
      });
    }
  }, [scanResults.showModal]); // Only track modal open/close

  if (!scanResults.showModal) return null;

  const handleClose = () => {
    hideScanResults();
  };

  // Use the existing ScanResultsModal with global state
  return ReactDOM.createPortal(
    <ScanResultsModal
      isOpen={scanResults.showModal}
      onClose={handleClose}
      scanData={scanResults.scanData}
      scanError={scanResults.error || undefined}
    />,
    document.body
  );
} 